'use strict';
var $ = jQuery;

(function ($) {

     /*  Cover slider  */
    $('.large-cover').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        infinite: true,
        fade: true,
        asNavFor: '.mini-cover'
    });

    /*  Cover slider  */
    $('.mini-cover').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        infinite: true,
        asNavFor: '.large-cover',
        focusOnSelect: true
    });

    /* Werke Quotes-Slider */
    $('.slider.quote-banner').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        infinite: true,
        fade: true,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 5000,
        centerPadding: '40px',
    });


     $('.hjr-gallery-slider').slick({
        //lazyLoad: 'ondemand',
        dots: false,
        infinite: true,
        //centerMode: true,
        variableWidth: true,
        focusOnSelect: true
    });



    /*

    $('.slider .blocks-gallery-grid').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: true,
        infinite: true,
        //centerMode: true,
        variableWidth: true,
        //&centerPadding: '40px',
        //adaptiveHeight: true
    });
    */

   
})(jQuery);
